
import { makeAutoObservable } from 'mobx';

class previewMedia {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    mediaVisible = false;

    config = { type: '', src: '' }

    toggleMediaVisible = flag => {
        console.log('flag', flag)
        this.mediaVisible = flag;
    };

    setMediaConfig = options => {
        console.log('options', options)
        this.config = options
    }
}

export default new previewMedia();
